/**
 * Static config for the Merchant Account Type (KYB tier) UI — the tier dropdown options, the per-tier
 * requirement-document NAMES shown in the edit modal + the User Documents tab, the accepted file
 * types/size, and a file-size formatter. This is configuration (not mock data): the upload + history now
 * go through the real backend (presign -> S3 PUT -> /merchant/update-account-type, and
 * /merchant/account-type-document-history / -download-document).
 *
 * NOTE: the per-tier requirement names below are confirmed only for "Small" from the mockup.
 * Medium / Corporate requirements are PLACEHOLDERS pending product confirmation — update
 * REQUIREMENTS_BY_TIER when the final lists are provided.
 */

// Tier options for the dropdown (data value + UI label). corporate -> "Corporate".
export const TIER_OPTIONS = [
  { value: 'micro', text: 'Micro' },
  { value: 'small', text: 'Small' },
  { value: 'medium', text: 'Medium' },
  { value: 'corporate', text: 'Corporate' },
];

export const TIER_LABELS = { micro: 'Micro', small: 'Small', medium: 'Medium', corporate: 'Corporate' };

/**
 * Document requirements per tier. Micro has none (default, most restrictive — no upgrade docs).
 * Small is from the mockup. Medium/Corporate are placeholders pending product confirmation.
 */
export const REQUIREMENTS_BY_TIER = {
  micro: [],
  small: [
    "Selfie together with Authorized Signatory's Valid ID",
    'Barangay Certificate or Barangay Clearance',
  ],
  medium: [
    "Selfie together with Authorized Signatory's Valid ID",
    'Barangay Certificate or Barangay Clearance',
    'DTI / SEC Registration', // placeholder — confirm with product
  ],
  corporate: [
    "Selfie together with Authorized Signatory's Valid ID",
    'SEC Registration & Articles of Incorporation', // placeholder — confirm with product
    'BIR Certificate of Registration (Form 2303)', // placeholder — confirm with product
  ],
};

export const ACCEPTED_TYPES = ['image/jpeg', 'image/png'];
export const MAX_FILE_BYTES = 15 * 1024 * 1024;

export function formatFileSize(bytes) {
  if (bytes === null || bytes === undefined) return '';
  const mb = bytes / (1024 * 1024);
  if (mb >= 1) return `${mb.toFixed(1)} MB`;
  return `${(bytes / 1024).toFixed(0)} KB`;
}
